import config from "config/config.js";

const searchCities = (text, language, latitude, longitude, timestamp) => {
  const endpoint = `${
    config.baseUrl
  }/api/search/app/only/cities/${longitude}/${latitude}/${language}/${text}/${timestamp}`;
  const options = {
    method: "get",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errrr", e);
    });
};

export default searchCities;
